
  import { Component, Prop, PropSync, Vue } from "vue-property-decorator";
  import { Contractor, Contractor_Rating_Aggregate } from "@/generated/graphql";
  import CardItemTitle from "@/components/card/CardItemTitle.vue";
  import ManagerChips from "@/components/managers/ManagerChips.vue";
  import CardItemContainer from "@/components/card/CardItemBaseContainer.vue";
  import CompanyContractorCard from "@/components/companyContractors/CompanyContractorCard.vue";
  import ToggleFavorite from "@/components/favorite/ToggleFavorite.vue";
  import CardItemChipsContainer from "@/components/card/CardItemChipsContainer.vue";
  import EmployeeCardName from "@/components/employee/EmployeeCardName.vue";
  import ContainerSize from "@/components/uiSize/ContainerSize.vue";

  @Component({
    components: {
      ContainerSize,
      EmployeeCardName,
      CardItemChipsContainer,
      ToggleFavorite,
      CompanyContractorCard,
      CardItemContainer,
      ManagerChips,
      CardItemTitle,
    },
  })
  export default class CompanyContractorAdminCard extends Vue {
    @Prop({ type: Object, required: true }) readonly contractor!: Contractor;
    @Prop({ type: Object, required: true }) readonly ratingTotal!: Contractor_Rating_Aggregate;
    @Prop({ type: String, required: true }) readonly userUpdatedDate!: string;
    @Prop({ type: String, required: true }) readonly currentUserId!: string;
    @Prop({ type: String, required: true }) readonly currentUserRole!: string;
    @Prop({ type: String, required: true }) readonly companyId!: string;
    @PropSync('nameBlockMinHeight', { type: Number, default: undefined }) nameBlockMinHeightValue?: number;
    @PropSync('skillsBlockMinHeight', { type: Number, default: undefined }) skillsBlockMinHeightValue?: number;
    @PropSync('managersBlockMinHeight', { type: Number, default: undefined }) managersBlockMinHeightValue?: number;
  }
